import Swal from "sweetalert2";
import HelperMixin from '../../../Shared/HelperMixin.vue';
import PaginationHelper from '../../../Shared/PaginationHelper.vue';

export default {
    name: 'VehicleTypes',
    mixins: [HelperMixin],
    components: { PaginationHelper },

    async created() {
        this.loginDetails = await this.CheckLoginStatus();
        if (!this.requireUserType([1])) return;
        this.GetInfo(this.pageNo);
    },

    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            Search: '',
            ScreenTitle: ' أنواع المركبات ',
            ScreenTitleSingle: ' نوع مركبة ',
            ScreenTitleSingleAl: 'نوع المركبة ',
            Info: [],
            Statistics: [],
            SelectedItem: '',
            ruleForm: {
                Id: '',
                Name: '',
                Descriptions: '',
                Image: '',
                ImageName: ''
            },
            rules: { Name: this.$helper.Required() }
        };
    },

    methods: {
        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) this.pageNo = 1;
            if (!this.Search) this.$blockUI.Start();
            this.$http.GetVehiclesTypes(this.pageNo, this.pageSize, this.Search)
                .then(response => {
                    if (!this.Search) this.$blockUI.Stop();
                    this.Info = response.data.info || [];
                    this.pages = response.data.count || 0;
                    this.Statistics = response.data.statistics || {};
                })
                .catch(() => {
                    if (!this.Search) this.$blockUI.Stop();
                    this.pages = 0;
                });
        },

        submitForm(formName) {
            const form = this.$refs[formName];
            if (!form) return;
            form.validate((valid) => {
                if (!valid) { this.$helper.showSwal('warning'); return; }
                this.ruleForm.Id = Number(0);
                this.$blockUI.Start();
                this.$http.AddVehiclesTypes(this.ruleForm)
                    .then(response => {
                        this.$blockUI.Stop();
                        this.GetInfo(this.pageNo);
                        this.ClearForm(this.ruleForm);
                        this.$helper.DestroyElemntById('CloseAdd');
                        this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('error', 'خطأ بعملية الإضافة', err.response && err.response.data ? err.response.data : 'حدث خطأ');
                    });
            });
        },

        OpentEditDialog(item) {
            this.SelectedItem = item;
            this.ruleForm.Id = item.id;
            this.ruleForm.Name = item.name;
            this.ruleForm.Descriptions = item.descriptions || '';
            this.ruleForm.Image = '';
            this.ruleForm.ImageName = '';
        },

        submitEditForm(formName) {
            const form = this.$refs[formName];
            if (!form) return;
            form.validate((valid) => {
                if (!valid) { this.$helper.showSwal('warning'); return; }
                this.ruleForm.Id = Number(this.ruleForm.Id);
                this.$blockUI.Start();
                this.$http.EditVehiclesTypes(this.ruleForm)
                    .then(response => {
                        this.$blockUI.Stop();
                        this.GetInfo(this.pageNo);
                        this.ClearForm(this.ruleForm);
                        this.$helper.DestroyElemntById('CloseEdit');
                        this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', err.response && err.response.data ? err.response.data : 'حدث خطأ');
                    });
            });
        },

        ChangeStatus(Id) {
            Swal.fire({
                title: 'تأكيد العملية',
                text: 'هل أنت متأكد من تغيير حالة العرض؟',
                icon: 'question',
                customClass: { confirmButton: 'btn btn-primary' },
                buttonsStyling: false,
                confirmButtonText: 'تأكيد'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.ChangeStatusVehiclesTypes(Id)
                        .then(() => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', 'تم تغيير الحالة بنجاح');
                            this.GetInfo(this.pageNo);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('error', 'خطأ', err.response && err.response.data ? err.response.data : 'حدث خطأ');
                        });
                }
            });
        },

        Delete(Id) {
            Swal.fire({
                title: 'تأكيد الحذف',
                text: 'هل أنت متأكد من الحذف؟',
                icon: 'question',
                customClass: { confirmButton: 'btn btn-primary' },
                buttonsStyling: false,
                confirmButtonText: 'تأكيد'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteVehiclesTypes(Id)
                        .then(() => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', 'تم الحذف بنجاح');
                            this.GetInfo(this.pageNo);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('error', 'خطأ', err.response && err.response.data ? err.response.data : 'حدث خطأ');
                        });
                }
            });
        },

        SelectImage(file) {
            if (!file) { this.$helper.ShowMessage('error', 'خطأ', 'يرجى اختيار ملف'); return; }
            if (file.type.substring(0, 5) !== 'image') { this.$helper.ShowMessage('error', 'خطأ', 'الرجاء اختيار صورة'); return; }
            const $this = this;
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                $this.ruleForm.ImageName = file.name;
                $this.ruleForm.Image = reader.result;
            };
        }
    }
};
